import React, { CSSProperties } from 'react';

type IconProps = {
  w?: number;
  h?: number;
  style?: CSSProperties;
  className?: string;
  fill?: string;
};

function TelegramIcon({ w = 24, h = 24, fill, style, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={w}
      height={h}
      fill={fill}
      style={style}
      viewBox="0 0 24 24"
      className={className}
    >
      <path
        fillRule="evenodd"
        d="M4.3 11.5L16.6 6A1 1 0 0 1 18 7L16.4 17a1.1 1.1 0 0 1-1.7.7l-4.3-3a.6.6 0 0 1 0-1l4.1-4.2a.2.2 0 0 0-.3-.4l-5.5 3.8a2.4 2.4 0 0 1-2.2.3l-2.2-.7a.5.5 0 0 1 0-1z"
      />
    </svg>
  );
}

export default TelegramIcon;
